import { render, staticRenderFns } from "./InvoiceApprovalList.vue?vue&type=template&id=6b81e391&"
import script from "./InvoiceApprovalList.vue?vue&type=script&lang=js&"
export * from "./InvoiceApprovalList.vue?vue&type=script&lang=js&"
import style0 from "./InvoiceApprovalList.vue?vue&type=style&index=0&id=6b81e391&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports